import {Component} from '@angular/core';

@Component({
  selector: 'app-link-consultations',
  templateUrl: './link-consultations.component.html',
  styleUrls: ['./link-consultations.component.scss']
})
export class LinkConsultationsComponent {
}
